import { render, staticRenderFns } from "./DailyDose.vue?vue&type=template&id=b38971ac&"
import script from "./DailyDose.vue?vue&type=script&lang=js&"
export * from "./DailyDose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports